/* import __COLOCATED_TEMPLATE__ from './header-cell.hbs'; */
/**
Header cell component yielded by `sq-table`, not intended for standalone use.

### Parameters
@param {Boolean} [isFixedLeft=false] - Fixes the column to the left, allowing other cells to horizonally scroll beneath it. Only works for cells in the first column.
```
*/

import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'th',
  classNames: ['sq-table__cell', 'sq-table__cell--header'],
  classNameBindings: ['isFixedLeft:sq-table__cell--is-fixed-left'],
  isFixedLeft: false
});